module.exports = __webpack_public_path__ + "adb8e956993913a44c836a2c93c11a9a.fbx";